import PortfolioGallery from './PortfolioGallery.page';

export default PortfolioGallery;